export default "__VITE_ASSET__Dulljxvt__"